import script from "./MusicQRcode.vue?vue&type=script&setup=true&lang=ts"
export * from "./MusicQRcode.vue?vue&type=script&setup=true&lang=ts"

import "./MusicQRcode.vue?vue&type=style&index=0&id=4e9a232b&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9a232b"]])

export default __exports__